export const formatCollaborator = (collaborator) => {
  const attributes = {};
  const relationships = {};
  const id = collaborator.id && collaborator.id !== 'dummy' ? collaborator.id : undefined;

  if (collaborator.nombre && collaborator.apellidos) {
    attributes.title = `${collaborator.nombre} ${collaborator.apellidos}`;
  } else if (collaborator.nombre) {
    attributes.title = collaborator.nombre;
  } else {
    attributes.title = collaborator.empresa;
  }
  if (collaborator.nombre) {
    attributes.collaborator_name = collaborator.nombre;
  }
  if (collaborator.apellidos) {
    attributes.collaborator_surname = collaborator.apellidos;
  }
  if (collaborator.empresa) {
    attributes.empresa = collaborator.empresa;
  }
  if (collaborator.telefono) {
    attributes.telefono = collaborator.telefono;
  }
  if (collaborator.comment) {
    attributes.comment = collaborator.comment;
  }
  return {
    data: {
      id,
      type: 'node--collaborator',
      attributes,
      relationships,
    },
  };
};

export const processCollaborator = (collaborator) => {
  const { attributes, id, type } = collaborator;
  const collaboratorModel = { id, type };
  if ('title' in attributes) {
    collaboratorModel.title = attributes.title;
  }
  if ('collaborator_name' in attributes) {
    collaboratorModel.nombre = attributes.collaborator_name;
  }
  if ('collaborator_surname' in attributes) {
    collaboratorModel.apellidos = attributes.collaborator_surname;
  }
  if ('comment' in attributes) {
    collaboratorModel.comment = attributes.comment;
  }
  if ('empresa' in attributes) {
    collaboratorModel.empresa = attributes.empresa;
  }
  if ('telefono' in attributes) {
    collaboratorModel.telefono = attributes.telefono;
  }
  return collaboratorModel;
};

export const processCollaboratorResponse = (res) => {
  if (res.data.meta) {
    return res.data.data.map(collaborator =>
      processCollaborator(collaborator));
  }
  return processCollaborator(res.data.data);
};



// WEBPACK FOOTER //
// ./src/features/colaborador/utils.js